import { render, staticRenderFns } from "./goodsGiftCount.vue?vue&type=template&id=2ee3beaf&scoped=true&"
import script from "./goodsGiftCount.vue?vue&type=script&lang=js&"
export * from "./goodsGiftCount.vue?vue&type=script&lang=js&"
import style0 from "./goodsGiftCount.vue?vue&type=style&index=0&id=2ee3beaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3beaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ee3beaf')) {
      api.createRecord('2ee3beaf', component.options)
    } else {
      api.reload('2ee3beaf', component.options)
    }
    module.hot.accept("./goodsGiftCount.vue?vue&type=template&id=2ee3beaf&scoped=true&", function () {
      api.rerender('2ee3beaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/saleDetail/goodsGiftCount.vue"
export default component.exports